import { getFeature, isFeature } from 'Cloud/Application/FeaturesEs6';

interface IConfig {
    queryEnabled: boolean;
    queryEnabledForEmbedded: boolean;
    queryEnabledForSocial: boolean;
    deviceType: 'all' | 'mobile' | 'desktop';
    corpEnabled: boolean;
    bizEnabled: boolean;
    socialEnabled: boolean;
    webViewEnabled: boolean;
    iframeEnabled: boolean;
    promoQuotaEnabled: boolean;
}

export const IS_CHECK_AB: boolean = isFeature('is-check-ab');

export const CHECK_AB_CONFIG: IConfig = getFeature('check-ab-config') || {
    queryEnabled: true,
    queryEnabledForEmbedded: false,
    queryEnabledForSocial: false,
    deviceType: 'mobile',
    corpEnabled: false,
    bizEnabled: false,
    socialEnabled: false,
    webViewEnabled: false,
    iframeEnabled: false,
    promoQuotaEnabled: false,
};
